export const ValidateRule = {
  EMAIL: /(?=^.{6,40}$)^[-\w]+(\.[-\w]+)*@[-\w]+(\.[-\w]+)+$/,
};
